var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclipVerticalSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "27px",
    viewBox: "0 0 18 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "paperclip-vertical-solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Digital-Settlements",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-page---Go-to-Digital-settlements---insurance-widget-Copy",
    transform: "translate(-114, -1600)",
    fill: "#D14200",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paperclip-vertical-solid",
    transform: "translate(114, 1600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.54545455 C0,2.930625 2.930625,0 6.54545455,0 C10.1607955,0 13.0909091,2.930625 13.0909091,6.54545455 L13.0909091,16.3636364 C13.0909091,18.6238636 11.2602273,20.4545455 9,20.4545455 C6.73977273,20.4545455 4.90909091,18.6238636 4.90909091,16.3636364 L4.90909091,8.18181818 C4.90909091,7.27670455 5.64034091,6.54545455 6.54545455,6.54545455 C7.45056818,6.54545455 8.18181818,7.27670455 8.18181818,8.18181818 L8.18181818,16.3636364 C8.18181818,16.8136364 8.55,17.1818182 9,17.1818182 C9.45,17.1818182 9.81818182,16.8136364 9.81818182,16.3636364 L9.81818182,6.54545455 C9.81818182,4.73778409 8.35056818,3.27272727 6.54545455,3.27272727 C4.74034091,3.27272727 3.27272727,4.73778409 3.27272727,6.54545455 L3.27272727,17.1818182 C3.27272727,20.3471591 5.83465909,22.9090909 9,22.9090909 C12.1653409,22.9090909 14.7272727,20.3471591 14.7272727,17.1818182 L14.7272727,8.18181818 C14.7272727,7.27670455 15.4585227,6.54545455 16.3636364,6.54545455 C17.26875,6.54545455 18,7.27670455 18,8.18181818 L18,17.1818182 C18,22.1522727 13.9704545,26.1818182 9,26.1818182 C4.02954545,26.1818182 0,22.1522727 0,17.1818182 L0,6.54545455 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclipVerticalSolid);
export default __webpack_public_path__ + "static/media/paperclip-vertical-solid.c0326076d9cbe9936c0f1ced08a17108.svg";
export { ForwardRef as ReactComponent };